var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_12997)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7782C0 15.0537 0.753337 15.1797 2.0573 15.8549L7.03125 18.4711C7.44799 18.6869 7.86451 18.9025 8.28126 19.1184C8.49021 19.2266 8.69778 19.334 8.90684 19.4414L14.5312 22.4358C15.5233 22.9491 18.8603 24.8631 19.7656 24.8631C21.0489 24.8631 21.1128 24.6914 22.2396 24.1079C22.8955 23.7683 23.4585 23.4767 24.1146 23.137C25.4059 22.4683 26.5516 21.8346 27.8385 21.1681L31.5619 19.1987C32.8017 18.5618 34.0927 17.9258 35.3125 17.2574L35.3189 31.0867C35.4894 32.41 37.5431 32.4089 37.6566 31.0128L37.6562 24.5395C37.6562 21.6806 37.6562 18.8217 37.6562 15.9628C37.9988 15.8801 38.6775 15.4747 39.0374 15.2895C39.6259 14.9868 39.9273 14.5672 40 14.1422V13.728C39.9281 13.3045 39.6391 12.9132 39.1936 12.6714L22.9688 4.1496C20.0366 2.63123 20.0014 2.61154 17.0833 4.12263C16.219 4.5702 15.4493 4.97268 14.583 5.41691L4.58436 10.6776C3.35815 11.3884 2.09912 11.9844 0.858192 12.6441C0.441867 12.8655 0 13.2125 0 13.7782Z",
    fill: "#FE8016"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03125 22.4356V31.4978C7.03125 31.7792 7.25541 32.0994 7.40815 32.2402C7.6582 32.4706 9.19136 33.2232 9.5573 33.4127L12.5 34.977C15.417 36.4874 17.0977 36.9998 20.5469 36.9998C21.8546 36.9998 23.3088 36.68 24.3068 36.3628C26.4265 35.689 28.4268 34.4566 30.3906 33.4396C31.2736 32.9824 32.9688 32.3692 32.9688 31.4978V22.4356C32.9688 22.0214 32.5579 21.6265 32.1875 21.6265C31.9552 21.6265 28.3213 23.5881 27.7865 23.865C26.4666 24.5485 22.7548 26.6115 21.9059 26.9178C20.5703 27.3996 19.5014 27.4011 18.1521 26.9386C17.5371 26.7278 11.6283 23.562 10.8073 23.1368C10.4003 22.9261 8.03408 21.6265 7.81251 21.6265C7.44212 21.6265 7.03125 22.0214 7.03125 22.4356Z",
    fill: "#FE8016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_12997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.8e19c0930d3c684e264825614b4a2ba7.svg";
export { ForwardRef as ReactComponent };